import React, { Fragment } from "react";
import { useDispatch } from "react-redux";
import { sortOptions, hasValue } from "../../utils/utils";
import { openModal } from "ducks/modal";
import { setGivingStep } from "ducks/givingFormV2";
import { setSectionId } from "ducks/matchingGifts";
import MatchCreateIcon from "shared/ui/svg-icons/MatchCreateIcon";
import classnames from "classnames";
import debounce from "lodash/debounce";
import MixpanelService from "shared/services/MixpanelService";

const Header = ({
  entityId,
  entityName,
  searchTerm,
  sort,
  sectionId,
  fetchData,
  selectId,
  featuresEnabled,
}) => {
  const dispatch = useDispatch();

  const handleOpenModal = () => {
    MixpanelService.trackCreateMatchingGiftClick(entityName);
    dispatch(setGivingStep("givingMatchingGiftCreate"));
    dispatch(openModal());
    if (sectionId) {
      dispatch(setSectionId(sectionId));
    }
  };

  const debouncedSearch = (value) => {
    fetchData(sectionId, entityId, 1, sort, value);
  };

  const search = debounce(debouncedSearch, 300);

  return (
    <Fragment>
      <div className="header">
        <select
          id={selectId}
          value={sort}
          onChange={(event) => {
            fetchData(sectionId, entityId, 1, event.target.value, searchTerm);
          }}>
          {sortOptions.map(({ name, value }) => (
            <option key={value} value={value}>
              {name}
            </option>
          ))}
        </select>
        <div className="content">
          <div
            className={classnames("search", {
              expanded: hasValue(searchTerm),
            })}>
            <input
              data-testid="t-Matchin-App--Header-input"
              value={searchTerm}
              onChange={(event) => search(event.target.value)}
              type="text"
              id="searchInput"
              className="search__input"
              aria-label="search matching gifts"
            />
            <button
              data-testid="t-Matchin-App--Header-submit-matching-gift"
              className="search__submit"
              aria-label="submit matching gifts search">
              <i className="fa fa-search" />
            </button>
          </div>
        </div>
        {featuresEnabled.includes("matching_gifts_self_signup") && (
          <button
            data-testid="t-Matchin-App--Header-button-3"
            className="primary-color-background create-matching-gift-button"
            onClick={handleOpenModal}>
            <MatchCreateIcon /> CREATE YOUR MATCHING GIFT
          </button>
        )}
      </div>
      {featuresEnabled.includes("matching_gifts_self_signup") && (
        <div
          className="primary-color-text create-matching-gift-mobile-button"
          onClick={handleOpenModal}>
          CREATE MATCHING GIFT <i className="fa fa-chevron-right" />
        </div>
      )}
    </Fragment>
  );
};

export default Header;
